import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import config from "./config";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Maintainance from "./pages/Maintainance";

const app = (
  <React.StrictMode>
    <HelmetProvider>
      {config.isMaintaining ? (
        <Maintainance />
      ) : (
        <Router>
          <App />
        </Router>
      )}
    </HelmetProvider>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");

// react-snap prerenders static HTML; hydrate it instead of re-rendering.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(app, rootElement);
} else {
  ReactDOM.render(app, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
